var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-list-group"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_vm._l((_vm.group.data),function(item,i){return _c('message-list',{key:i,attrs:{"data":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }